import AppErrorBoundary from 'components/AppErrorBoundary/AppErrorBoundary'
import { useEffect } from 'react'
import Router from './Router'

import AppLoader from 'components/Loader/AppLoader/AppLoader'
import hocConnect from './hocApp'

function App({ getToken, tokenLoading }) {
    useEffect(() => {
        // Check or request token
        getToken()
    }, [])

    return (
        <div id="app">
            <AppErrorBoundary> {tokenLoading ? <AppLoader /> : <Router />} </AppErrorBoundary>
        </div>
    )
}

export default hocConnect(App)
